module.exports = __webpack_public_path__ + "media/situations/list-limited-899b9f65.jpg";